import React, { useState } from 'react';
import MainImage from '../../images/portfolio/CrispinGlover/HeroImage.jpg';
import Concept from '../../images/portfolio/CrispinGlover/Concept-1.jpg';
import Concept_2 from '../../images/portfolio/CrispinGlover/Concept-2.jpg';
import album from '../../images/portfolio/CrispinGlover/album.png';
import TShirt from '../../images/portfolio/CrispinGlover/tshirt.jpg';
import TShirt_2 from '../../images/portfolio/CrispinGlover/tshirt-2.jpg';
import PortfolioPage from '../../components/PortfolioPage';
import { useT } from '../../i18n';

const PortfolioCrispinGlover = () => {
    const t = useT();
    return <PortfolioPage img={MainImage} url="https://player.vimeo.com/video/651689150" title="Crispin Glover Records" description={t(
      "I samarbeid med Crispin Glover Records, har vi produsert en dyster musikkvideo til sangen No Santa Clauses, av Patrik Fitzgerald feat. Lemur. Dette oppdraget utførte vi før julen 2021. Musikkvideoen tar mye inspirasjon fra Tim Burton og Edward Gorey. Sangen omhandler barn som ble brukt for å rense piper i England på 1800-tallet, hvor mange av barna omkom. Det var derfor viktig å formulere en dyster stemning i tegnestil, lys og bevegelse. (2021)",
      "Together with Crispin Glover Records, we produced a dark music video for the song No Santa Clauses by Patrik Fitzgerald feat. Lemur, made in the run-up to Christmas 2021. The video draws heavily on Tim Burton and Edward Gorey. The song is about children who were used as chimney sweeps in 19th-century England, many of whom died. It was therefore important to create a dark mood through the drawing style, lighting and movement. (2021)"
    )}>
         <div className="flex  mt-32 lg:px-0">
            <div className="max-w-sm">
              <img src={Concept}  />
              <img src={Concept_2} />
            </div>
          </div>

          <div className="flex flex-wrap justify-center mt-32 md:justify-between">
            <img src={album} className="mr-16" style={{height: "350px"}} />
            <img src={TShirt}  style={{height: "350px"}}/>
          </div>
          <img src={TShirt_2}  style={{height: "350px"}}/>
    </PortfolioPage>

}

export default PortfolioCrispinGlover;
